export enum BOOKMARK_TOOLTIP {
  DESCRIPTION = 'Log in met je gratis account om dit programma aan je favorieten toe te kunnen voegen.',
  BUTTON_TEXT = 'Inloggen'
}
